import { RealityDimensionId, AbstractDimensionId } from '../types';

export type Dimension12D = RealityDimensionId | AbstractDimensionId;

export interface CharacterDefinition {
  id: string;
  name: string;
  pool: 'real' | 'abstract';
  image: string;
  coordinates: Record<Dimension12D, number>;
  personaKeywords: string[];
}

export const CHARACTER_REGISTRY: CharacterDefinition[] = [
  // ==================== 现实宠物池 (Real Pet Pool - 33种) ====================
  {
    id: 'golden_retriever',
    name: '金毛',
    pool: 'real',
    image: '/characters/golden_retriever.png',
    coordinates: { C: 5, E: 4, I: 1, S: 2, M: 3, P: 4, V: 4, N: 1, X: 2, A: 1, B: 1, R: 1 },
    personaKeywords: ['热情阳光', '高服从度', '极度黏人', '稳定陪伴']
  },
  {
    id: 'border_collie',
    name: '边牧',
    pool: 'real',
    image: '/characters/border_collie.png',
    coordinates: { C: 4, E: 5, I: 2, S: 4, M: 5, P: 4, V: 4, N: 1, X: 2, A: 1, B: 1, R: 2 },
    personaKeywords: ['超高智商', '活力充沛', '需要持续训练', '敏锐警觉']
  },
  {
    id: 'alaskan_malamute',
    name: '阿拉斯加',
    pool: 'real',
    image: '/characters/alaskan_malamute.png',
    coordinates: { C: 4, E: 4, I: 2, S: 2, M: 5, P: 5, V: 5, N: 2, X: 3, A: 2, B: 2, R: 2 },
    personaKeywords: ['大体格憨厚', '极高运动量', '毛量惊人', '热情奔放']
  },
  {
    id: 'shiba_inu',
    name: '柴犬',
    pool: 'real',
    image: '/characters/shiba_inu.png',
    coordinates: { C: 2, E: 3, I: 5, S: 3, M: 3, P: 3, V: 3, N: 1, X: 2, A: 1, B: 2, R: 4 },
    personaKeywords: ['独立固执', '边界感强', '猫性犬类', '傲娇自洽']
  },
  {
    id: 'pomeranian',
    name: '博美',
    pool: 'real',
    image: '/characters/pomeranian.png',
    coordinates: { C: 5, E: 3, I: 1, S: 4, M: 4, P: 1, V: 5, N: 1, X: 3, A: 2, B: 2, R: 2 },
    personaKeywords: ['小巧机灵', '警惕性高', '强存在感', '撒娇精']
  },
  {
    id: 'french_bulldog',
    name: '法斗',
    pool: 'real',
    image: '/characters/french_bulldog.png',
    coordinates: { C: 4, E: 2, I: 2, S: 2, M: 3, P: 2, V: 4, N: 1, X: 2, A: 2, B: 4, R: 1 },
    personaKeywords: ['沉稳安静', '宅家友好', '怕热易疲劳', '憨态可掬']
  },
  {
    id: 'ragdoll_cat',
    name: '布偶猫',
    pool: 'real',
    image: '/characters/ragdoll_cat.png',
    coordinates: { C: 5, E: 2, I: 2, S: 3, M: 3, P: 2, V: 3, N: 1, X: 1, A: 1, B: 3, R: 1 },
    personaKeywords: ['温顺亲人', '容忍度高', '仙女颜值', '需要梳毛照顾']
  },
  {
    id: 'british_shorthair',
    name: '英短',
    pool: 'real',
    image: '/characters/british_shorthair.png',
    coordinates: { C: 3, E: 2, I: 4, S: 2, M: 2, P: 2, V: 2, N: 1, X: 1, A: 1, B: 3, R: 1 },
    personaKeywords: ['低调独立', '安静省心', '圆润耐看', '界限分明']
  },
  {
    id: 'siamese_cat',
    name: '暹罗猫',
    pool: 'real',
    image: '/characters/siamese_cat.png',
    coordinates: { C: 5, E: 3, I: 1, S: 4, M: 3, P: 2, V: 5, N: 2, X: 3, A: 2, B: 2, R: 3 },
    personaKeywords: ['话密黏人', '好奇心强', '像小狗的猫', '情感热烈']
  },
  {
    id: 'orange_tabby_cat',
    name: '橘猫',
    pool: 'real',
    image: '/characters/orange_tabby_cat.png',
    coordinates: { C: 3, E: 1, I: 4, S: 1, M: 2, P: 2, V: 3, N: 1, X: 2, A: 3, B: 5, R: 1 },
    personaKeywords: ['干饭积极', '随遇而安', '易胖体质', '松弛感拉满']
  },
  {
    id: 'sphynx_cat',
    name: '无毛猫',
    pool: 'real',
    image: '/characters/sphynx_cat.png',
    coordinates: { C: 5, E: 3, I: 2, S: 4, M: 5, P: 2, V: 4, N: 3, X: 2, A: 3, B: 2, R: 2 },
    personaKeywords: ['高体温亲人', '极其黏人', '皮肤需精细护理', '先锋外观']
  },
  {
    id: 'rabbit',
    name: '兔子',
    pool: 'real',
    image: '/characters/rabbit.png',
    coordinates: { C: 2, E: 2, I: 4, S: 5, M: 4, P: 2, V: 1, N: 2, X: 1, A: 1, B: 2, R: 1 },
    personaKeywords: ['胆小敏感', '安静吃草', '肠道脆弱', '软萌草食']
  },
  {
    id: 'hamster',
    name: '仓鼠',
    pool: 'real',
    image: '/characters/hamster.png',
    coordinates: { C: 1, E: 2, I: 5, S: 3, M: 2, P: 1, V: 1, N: 2, X: 2, A: 2, B: 3, R: 1 },
    personaKeywords: ['夜行独居', '极低空间占用', '仓储大师', '省心小宠']
  },
  {
    id: 'guinea_pig',
    name: '豚鼠',
    pool: 'real',
    image: '/characters/guinea_pig.png',
    coordinates: { C: 3, E: 1, I: 2, S: 4, M: 3, P: 2, V: 2, N: 2, X: 1, A: 2, B: 3, R: 1 },
    personaKeywords: ['叫声丰富', '胆小温顺', '群体共鸣', '素食小猪']
  },
  {
    id: 'chinchilla',
    name: '龙猫',
    pool: 'real',
    image: '/characters/chinchilla.png',
    coordinates: { C: 2, E: 2, I: 4, S: 5, M: 4, P: 2, V: 2, N: 3, X: 1, A: 2, B: 2, R: 1 },
    personaKeywords: ['手感丝滑', '极度怕热', '需要沙浴', '神圣毛丝鼠']
  },
  {
    id: 'ferret',
    name: '雪貂',
    pool: 'real',
    image: '/characters/ferret.png',
    coordinates: { C: 4, E: 5, I: 2, S: 2, M: 4, P: 3, V: 5, N: 4, X: 5, A: 4, B: 1, R: 3 },
    personaKeywords: ['好奇心爆炸', '钻洞狂魔', '体能永动机', '偷藏小物件']
  },
  {
    id: 'parrot',
    name: '鹦鹉',
    pool: 'real',
    image: '/characters/parrot.png',
    coordinates: { C: 5, E: 4, I: 1, S: 4, M: 4, P: 2, V: 5, N: 4, X: 4, A: 4, B: 1, R: 3 },
    personaKeywords: ['语言模仿', '强互动需求', '聪明长寿', '声量惊人']
  },
  {
    id: 'betta_fish',
    name: '斗鱼',
    pool: 'real',
    image: '/characters/betta_fish.png',
    coordinates: { C: 1, E: 1, I: 5, S: 1, M: 2, P: 1, V: 2, N: 3, X: 1, A: 2, B: 4, R: 1 },
    personaKeywords: ['独立好斗', '微型桌面生态', '免充氧省心', '静默优雅']
  },
  {
    id: 'turtle',
    name: '乌龟',
    pool: 'real',
    image: '/characters/turtle.png',
    coordinates: { C: 1, E: 1, I: 5, S: 1, M: 2, P: 2, V: 1, N: 3, X: 1, A: 2, B: 5, R: 1 },
    personaKeywords: ['极长寿命', '慢节奏生活', '极低互动压力', '玄武神兽']
  },
  {
    id: 'axolotl',
    name: '六角恐龙',
    pool: 'real',
    image: '/characters/axolotl.png',
    coordinates: { C: 1, E: 1, I: 5, S: 3, M: 4, P: 2, V: 3, N: 5, X: 2, A: 4, B: 3, R: 1 },
    personaKeywords: ['呆萌微笑', '水质温度敏感', '再生奇迹', '远古两栖']
  },
  {
    id: 'leopard_gecko',
    name: '豹纹守宫',
    pool: 'real',
    image: '/characters/leopard_gecko.png',
    coordinates: { C: 1, E: 1, I: 5, S: 2, M: 2, P: 1, V: 2, N: 5, X: 1, A: 3, B: 3, R: 1 },
    personaKeywords: ['无声省心', '定点排便', '花纹绚丽', '脱皮小龙']
  },
  {
    id: 'bearded_dragon',
    name: '鬃狮蜥',
    pool: 'real',
    image: '/characters/bearded_dragon.png',
    coordinates: { C: 2, E: 2, I: 4, S: 2, M: 3, P: 2, V: 3, N: 5, X: 2, A: 4, B: 4, R: 1 },
    personaKeywords: ['性情温驯', '需要UVB晒台', '互动感强', '微型霸王龙']
  },
  {
    id: 'corn_snake',
    name: '玉米蛇',
    pool: 'real',
    image: '/characters/corn_snake.png',
    coordinates: { C: 1, E: 1, I: 5, S: 1, M: 2, P: 1, V: 3, N: 5, X: 1, A: 4, B: 3, R: 2 },
    personaKeywords: ['冷峻优雅', '进食周期长', '脱皮生长', '安静密友']
  },
  {
    id: 'bengal_cat',
    name: '孟加拉豹猫',
    pool: 'real',
    image: '/characters/bengal_cat.png',
    coordinates: { C: 3, E: 5, I: 3, S: 3, M: 4, P: 3, V: 5, N: 4, X: 4, A: 3, B: 1, R: 3 },
    personaKeywords: ['高能探索', '聪明', '野性', '不适合纯躺平']
  },
  {
    id: 'cockatiel',
    name: '玄凤鹦鹉',
    pool: 'real',
    image: '/characters/cockatiel.png',
    coordinates: { C: 5, E: 3, I: 1, S: 4, M: 4, P: 2, V: 4, N: 4, X: 3, A: 3, B: 1, R: 2 },
    personaKeywords: ['黏人', '敏感', '爱互动', '轻话痨']
  },
  {
    id: 'corgi',
    name: '柯基',
    pool: 'real',
    image: '/characters/corgi.png',
    coordinates: { C: 4, E: 4, I: 2, S: 2, M: 3, P: 3, V: 5, N: 2, X: 4, A: 3, B: 2, R: 4 },
    personaKeywords: ['快乐', '倔', '戏多', '小体型高能量']
  },
  {
    id: 'golden_shaded_cat',
    name: '金渐层',
    pool: 'real',
    image: '/characters/golden_shaded_cat.png',
    coordinates: { C: 4, E: 2, I: 3, S: 2, M: 3, P: 2, V: 4, N: 2, X: 1, A: 2, B: 4, R: 1 },
    personaKeywords: ['精致享受', '宅', '稳定', '被伺候型']
  },
  {
    id: 'hedgehog',
    name: '刺猬',
    pool: 'real',
    image: '/characters/hedgehog.png',
    coordinates: { C: 1, E: 2, I: 5, S: 4, M: 3, P: 1, V: 2, N: 4, X: 2, A: 3, B: 3, R: 3 },
    personaKeywords: ['慢热', '防御', '边界感强', '别随便碰我']
  },
  {
    id: 'maine_coon',
    name: '缅因猫',
    pool: 'real',
    image: '/characters/maine_coon.png',
    coordinates: { C: 4, E: 3, I: 3, S: 2, M: 4, P: 4, V: 5, N: 2, X: 2, A: 2, B: 2, R: 1 },
    personaKeywords: ['大型温柔', '稳重', '强存在感', '不咋咋呼呼']
  },
  {
    id: 'husky',
    name: '哈士奇',
    pool: 'real',
    image: '/characters/husky.png',
    coordinates: { C: 4, E: 5, I: 2, S: 1, M: 5, P: 4, V: 5, N: 3, X: 5, A: 4, B: 1, R: 5 },
    personaKeywords: ['高能量', '高失控', '高逆反', '现实宠物池里的合法抽象生物']
  },
  {
    id: 'samoyed',
    name: '萨摩耶',
    pool: 'real',
    image: '/characters/samoyed.png',
    coordinates: { C: 5, E: 4, I: 1, S: 2, M: 5, P: 4, V: 5, N: 2, X: 3, A: 2, B: 1, R: 1 },
    personaKeywords: ['阳光社交', '热情', '高存在感', '高维护']
  },
  {
    id: 'toy_poodle',
    name: '玩具贵宾 / 泰迪',
    pool: 'real',
    image: '/characters/toy_poodle.png',
    coordinates: { C: 5, E: 4, I: 1, S: 4, M: 5, P: 2, V: 4, N: 2, X: 3, A: 2, B: 1, R: 2 },
    personaKeywords: ['聪明', '黏人', '敏感', '精细养护']
  },
  {
    id: 'sugar_glider',
    name: '蜜袋鼯',
    pool: 'real',
    image: '/characters/sugar_glider.png',
    coordinates: { C: 5, E: 4, I: 1, S: 5, M: 5, P: 2, V: 4, N: 5, X: 4, A: 4, B: 1, R: 2 },
    personaKeywords: ['夜行', '高依赖', '高敏感', '高异宠浓度']
  },

  // ==================== 抽象角色池 (Abstract Pool - 10种) ====================
  {
    id: 'nailong',
    name: '奶龙',
    pool: 'abstract',
    image: '/characters/nailong.png',
    coordinates: { C: 4, E: 2, I: 1, S: 2, M: 1, P: 2, V: 5, N: 5, X: 3, A: 5, B: 5, R: 1 },
    personaKeywords: ['快乐摆烂', '高抽象', '低自理', '无脑乐观']
  },
  {
    id: 'naiwa',
    name: '奶蛙',
    pool: 'abstract',
    image: '/characters/naiwa.png',
    coordinates: { C: 3, E: 3, I: 3, S: 2, M: 1, P: 1, V: 4, N: 5, X: 4, A: 5, B: 3, R: 5 },
    personaKeywords: ['二创叛逆', '高互联网浓度', '高逆反', '可爱污染']
  },
  {
    id: 'niulai',
    name: '牛来',
    pool: 'abstract',
    image: '/characters/niulai.png',
    coordinates: { C: 2, E: 4, I: 3, S: 1, M: 1, P: 4, V: 5, N: 5, X: 5, A: 5, B: 2, R: 4 },
    personaKeywords: ['粗糙生命力', '猎奇', '失控', '莫名逆袭']
  },
  {
    id: 'daishu',
    name: '袋鼠',
    pool: 'abstract',
    image: '/characters/daishu.png',
    coordinates: { C: 5, E: 3, I: 1, S: 2, M: 2, P: 3, V: 4, N: 4, X: 2, A: 4, B: 1, R: 2 },
    personaKeywords: ['托底', '鼓励', '安全感', '胆子放心变肥', '憨厚保护型']
  },
  {
    id: 'xionggou',
    name: '熊狗',
    pool: 'abstract',
    image: '/characters/xionggou.png',
    coordinates: { C: 3, E: 5, I: 2, S: 1, M: 1, P: 4, V: 5, N: 4, X: 5, A: 4, B: 2, R: 3 },
    personaKeywords: ['莽', '憨', '先干再说', '低思考高行动', '容易被带偏']
  },
  {
    id: 'beishou_fushu',
    name: '背手负鼠',
    pool: 'abstract',
    image: '/characters/beishou_fushu.png',
    coordinates: { C: 1, E: 1, I: 5, S: 3, M: 1, P: 1, V: 3, N: 5, X: 2, A: 5, B: 5, R: 2 },
    personaKeywords: ['表面淡定', '内心崩坏', '冷处理', '高摆烂']
  },
  {
    id: 'xiugou',
    name: '修勾',
    pool: 'abstract',
    image: '/characters/xiugou.png',
    coordinates: { C: 5, E: 4, I: 1, S: 2, M: 1, P: 2, V: 4, N: 4, X: 3, A: 4, B: 2, R: 1 },
    personaKeywords: ['单纯', '热情', '直线脑回路', '乐于跟随']
  },
  {
    id: 'shutiao_xiaomao',
    name: '薯条小猫',
    pool: 'abstract',
    image: '/characters/shutiao_xiaomao.png',
    coordinates: { C: 4, E: 1, I: 3, S: 3, M: 1, P: 1, V: 3, N: 5, X: 2, A: 5, B: 4, R: 2 },
    personaKeywords: ['无害', '软', '莫名其妙', '低攻击性抽象']
  },
  {
    id: 'diangu',
    name: '癫菇',
    pool: 'abstract',
    image: '/characters/diangu.png',
    coordinates: { C: 2, E: 5, I: 3, S: 1, M: 1, P: 1, V: 5, N: 5, X: 5, A: 5, B: 2, R: 4 },
    personaKeywords: ['纯失控', '乐子人', '高刺激偏好', '精神状态非常自由']
  },
  {
    id: 'belial',
    name: '贝利亚',
    pool: 'abstract',
    image: '/characters/nailong.png', // 暂时缺独立图片，先以占位图指代
    coordinates: { C: 1, E: 5, I: 5, S: 1, M: 1, P: 5, V: 5, N: 4, X: 5, A: 4, B: 1, R: 5 },
    personaKeywords: ['攻击型逆反', '高能量', '反规则', '毁灭倾向']
  }
];

export const CHARACTER_MAP: Record<string, CharacterDefinition> = Object.fromEntries(
  CHARACTER_REGISTRY.map((c) => [c.id, c])
);

